import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, of, throwError} from 'rxjs';
import {catchError, filter, mergeMap, shareReplay} from 'rxjs/operators';
import {ProjectService} from '../../../shared/services/project.service';
import {IEmailForm} from '../../../shared/interfaces/iemail-form';
import {INewsletterOtoForm} from '../../../shared/interfaces/inewsletter-oto-form';
import {EnvironmentService} from '../../../shared/services/environment.service';
import {Agenzia} from '../../store-locator-page/interfaces/agenzia.interface';
import {CmsService} from '../../../cms/services/cms.service';
import {TemplateTypes} from '../../../shared/models/template-types.enum';
import {ModalGenericInfoComponent} from '../../../shared/components/modal-generic-info/modal-generic-info.component';
import {ContentTypes} from '../../../shared/models/content-types.enum';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { UrlSites } from 'src/app/enums/url-sites.enum';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  private isIstituzionale: boolean = false;

  constructor(private _http: HttpClient,
              private _environmentService: EnvironmentService,
              private _projectService: ProjectService,
              private _modalService: NgbModal,
              private _cmsService: CmsService,
  ) {

    this._cmsService.siteUrl$
      .pipe(filter(siteUrl => !!siteUrl?.length))
      .subscribe(siteUrl => {
        const istituzionali = [
          UrlSites.WTSTORE,
          UrlSites.WELCOMETRAVELSHOP,
          UrlSites.VACANZEWELCOMETRAVEL
        ];
        this.isIstituzionale = istituzionali.some(istituzionale => siteUrl.includes(istituzionale));
      });

  }

  subscribeGeo(params: IEmailForm): Observable<any> {
    return forkJoin([
      this._projectService.getServiceKey(),
    ]).pipe(
      mergeMap(e => {
        const url = 'https://core2.offertetouroperator.com/~geo-thebox-proxy/dist/index.php/newsletter/iscrivi';

        return this._http.post<any>(url, {
          agenzia_id: e[0],
          nome: params.name,
          cognome: params.surname,
          email: params.email
        }).pipe(shareReplay({bufferSize: 1, refCount: true}));
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  subscribeNewsletterOTO(params: INewsletterOtoForm): Observable<any> {
    return forkJoin([
      this._projectService.getProject(),
      this._environmentService.getEnvironment(),
      this._projectService.getAgencyApikey()
    ]).pipe(
      mergeMap(e => {
        const [project, environment, agencyApikey] = e;
        const url = `${environment.otoApi2UrlDynamic}generic/nauth/${params.selectedAgencyApikey || agencyApikey}/newsletter/signup`;
        const body = {
          externalId: params.externalAgencyId,
          name: params.name,
          surname: params.surname,
          marketingEmailConsent: 'Yes',
          // marketingPhoneWithOperatorConsent: 'No',
          // marketingPhoneWithoutOperatorConsent: 'No',
          // marketingPaperConsent: 'No',
          // profilingConsent: 'No',
          // thirdPartyConsent: 'No',
          privacyConsent: 1,
          domain: params.domain || project?.project?.domain,
          email: params.email,
          privacyPolicyText: params.privacyPolicyText || 'Newsletter',
          personLeadSource: params?.personLeadSource || 'Iscrizione NL',
          technicalSource: params?.technicalSource || 'Webservice Integration'
        };
        return this._http.post<any>(url, body).pipe(shareReplay({bufferSize: 1, refCount: true}));
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  public openPrivacyNewsletter(
    selectedStore: Agenzia
  ) {

    const modalRef = this._modalService.open(ModalGenericInfoComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
    modalRef.componentInstance.title = 'Informativa privacy newsletter';
    modalRef.componentInstance.template = this.isIstituzionale ?
      TemplateTypes.WTISTITUZIONALE_NEWSLETTER :
      TemplateTypes.GEO_PRIVACY_NEWSLETTER;
    modalRef.componentInstance.content = ContentTypes.ECOMMERCE;
    const apikey = selectedStore?.apiKey;
    if (apikey) {
      modalRef.componentInstance.selectedAgencyApikey = apikey;
    }
    return modalRef;
  }

}
